// extracted by mini-css-extract-plugin
export default {"header":"slots_header__j6zPs","weekend":"slots_weekend__WwziY"};